import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/11_poppies/11_poppies"
 * Contains 1 texture(s)
 */
export class Desktop11PoppiesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/11_poppies/11_poppies';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '11_poppies.jpg'
    ] as const;
}
